export default __webpack_public_path__ + "static/media/img--design-9.03689d5b.jpg";